import { render, staticRenderFns } from "./DataCategory3.vue?vue&type=template&id=b43ff374"
import script from "./DataCategory3.vue?vue&type=script&lang=js"
export * from "./DataCategory3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports